import React from 'react';
import ForwardValuationWidgetRenderer from './ForwardValuationWidgetRenderer';

const Preview: React.FC = () => (
  <ForwardValuationWidgetRenderer config={{}} />
);

export default Preview;
